module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ol', {
    staticClass: "cd-multi-steps text-bottom count"
  }, _vm._l((_vm.messages()), function(m, cpt) {
    return _c('li', {
      class: {
        'visited': cpt < _vm.step, 'current': cpt == _vm.step
      }
    }, [(cpt < _vm.step) ? _c('a', {
      attrs: {
        "href": "#0"
      }
    }, [_vm._v(_vm._s(m))]) : _c('em', [_vm._v(_vm._s(m))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c18d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/wizard.vue
// module id = 772
// module chunks = 0